function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-myself_svg__a",
  x1: 59.27,
  y1: 87.95,
  x2: 18.68,
  y2: -3.18,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#80e8bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d2f7e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-myself_svg__b",
  x1: 43.04,
  y1: 95.18,
  x2: 2.45,
  y2: 4.05,
  xlinkHref: "#1-myself_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 20,
  r: 20,
  fill: "url(#1-myself_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 66H0a22 22 0 0122-22h14a22 22 0 0122 22z",
  fill: "url(#1-myself_svg__b)"
}));

function Svg1Myself(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 66"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNTggNjYiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjU5LjI3IiB5MT0iODcuOTUiIHgyPSIxOC42OCIgeTI9Ii0zLjE4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjODBlOGJiIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZDJmN2U3Ii8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSI0My4wNCIgeTE9Ijk1LjE4IiB4Mj0iMi40NSIgeTI9IjQuMDUiIHhsaW5rOmhyZWY9IiNhIi8+PC9kZWZzPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGNpcmNsZSBjeD0iMjkiIGN5PSIyMCIgcj0iMjAiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNNTggNjZIMGEyMiAyMiAwIDAxMjItMjJoMTRhMjIgMjIgMCAwMTIyIDIyeiIgZmlsbD0idXJsKCNiKSIvPjwvZz48L3N2Zz4=";
export { Svg1Myself as ReactComponent };